/**
 * Ende der Klammer, die bei `open` beginnt (verschachtelte Klammern zählen mit, maskierte nicht); keine Leerzeile dazwischen. Gemeinsam
 * für Bezüge (`[…]{@clara}`) und Zeitmarken (`[…]{zeit …}`). -1, wenn es keine gibt.
 */
export function closingBracket(text: string, open: number): number {
  let depth = 0;
  for (let i = open; i < text.length; i++) {
    const c = text[i];
    if (c === '\\') {
      i++;
      continue;
    }
    if (c === '\n' && text[i + 1] === '\n') return -1;
    if (c === '[') depth++;
    else if (c === ']' && --depth === 0) return i;
  }
  return -1;
}
